import React, {Component} from 'react';
import {VehicleDetails} from './VehicleDetails';
import {CommodityDetails} from './CommodityDetails';

//TODO: Either at least one commodity or one vehicle has to be listed
export class ContainerDetails extends Component{

    constructor(props){
        super(props);        
        this.state = {           
            
            vehicleInputData: [],
            commodityInputData: [],
            vehicleInputPrefix: "containerInfo[" + this.props.id + "].vehicleInfo",
            commodityInputPrefix: "containerInfo[" + this.props.id + "].commodityInfo",
            
        }
        this.addVehicleToContainer = this.addVehicleToContainer.bind(this);
        this.removeVehicleFromContainer = this.removeVehicleFromContainer.bind(this);
        this.onUpdateVehicle = this.onUpdateVehicle.bind(this);
    }
    
    onUpdateVehicle = (id,key,value) =>{
        var vehicleInputData = this.state.vehicleInputData;
        vehicleInputData[id][key] = value;
        this.setState({vehicleInputData: vehicleInputData});
    }
    onUpdateCommodity = (id,key,value) =>{
        var commodityInputData = this.state.commodityInputData;
        commodityInputData[id][key] = value;
        this.setState({commodityInputData: commodityInputData});
    }

    addVehicleToContainer = () =>
    {
        var vehicleInputData = this.state.vehicleInputData;
        if(vehicleInputData.length < parseInt(this.props.maxVehicles, 10))
        {            
            var newInput = JSON.parse(JSON.stringify(VehicleDetails.defaultVehicleInputData));
            vehicleInputData.push(newInput);
        }
        this.setState({vehicleInputData: vehicleInputData});
    }  
    removeVehicleFromContainer = (index) =>
    {
        var vehicleInputData = this.state.vehicleInputData;
        var numVehicles = vehicleInputData.length;
        if(index < numVehicles && index >= 0)
        {
            vehicleInputData.splice(index,1);
        }
        this.setState({vehicleInputData: vehicleInputData});
    }
    
    addCommodityToContainer = () =>
    {
        var commodityInputData = this.state.commodityInputData;
        if(commodityInputData.length < parseInt(this.props.maxCommodities, 10))
        {
            // bge caredul when assigning an object to a component. Changes to the object
            // will be reflected across all components that have a REFERENCE to the object,
            // By default, assignment copies a reference to the original object rather than creating 
            // a copy.
            //https://scotch.io/bar-talk/copying-objects-in-javascript 
            var newInput = JSON.parse(JSON.stringify(CommodityDetails.defaultCommodityInputData));
            commodityInputData.push(newInput);
        }
        this.setState({commodityInputData: commodityInputData});
    }  
    removeCommodityFromContainer = (index) =>
    {
        var commodityInputData = this.state.commodityInputData;
        var numCommodities = commodityInputData.length;
        if(index < numCommodities && index >= 0)
        {
            commodityInputData.splice(index,1);
        }
        this.setState({commodityInputData: commodityInputData});
    }

    containerInfo(props) {
        var sizeInput = "containerInfo[" + props.id + "].sizes";
        var addlInfoInput = "containerInfo[" + props.id + "].additionalInformation";
        return (                                        
            <div className="row">
                <div className="col-12 display-5 mb-2">Container {parseInt(props.id,10) + 1}</div>    
                <div className="col-md-6 col-sm-8 mt-sm-2">
                    <label asp-for="containerInfo.sizes" className="control-label">Container size</label>
                    <select name={sizeInput} className="form-select">
                        <option value={0}>20 ft</option>
                        <option value={1}>40 ft</option>
                    </select>
                    <span asp-validation-for="containerInfo.sizes" className="text-danger"></span>
                </div>
                <div className="col-md-12 col-sm-8 mt-sm-2">
                    <label asp-for="containerInfo.additionalInformation" className="control-label">Additional Information</label>
                    <textarea rows="3" name={addlInfoInput} className="form-control"></textarea>
                    <span asp-validation-for="containerInfo.additionalInformation" className="text-danger"></span>        
                </div>
            </div>            
        );
    }

    // TODO: Implement autocollapse of vehicle with a display that includes a summary of the entered details
    // TODO: Implement AJAX to populate the options found in lists. Hardcoding this currently for efficency sake
    render(){
        var id = 0;
        var vehicleDetailsList = this.state.vehicleInputData.map((element) => 
            <div className="col-sm-12 col-md-6 mb-2">
                <div className="card border p-2">
                    <VehicleDetails key={id} id={id++} inputFor={this.state.vehicleInputPrefix}
                        onRemoveVehicle={this.removeVehicleFromContainer} 
                        value={element} onUpdate={this.onUpdateVehicle}/>
                </div>
            </div>
        );
        id = 0;
        var commodityDetailsList = this.state.commodityInputData.map((element) =>
            <CommodityDetails key={id} id={id++} inputFor={this.state.commodityInputPrefix}
                onRemoveContainer={this.removeCommodityFromContainer} 
                value={element} onUpdate={this.onUpdateCommodity}/>
        );
        return(
            <div className="col-12 mt-2">
                <div className="card border border-black p-2">
                    <div className="row">
                        <div className="col-sm-12 col-md-6 mt-2">
                            <this.containerInfo id={this.props.id}></this.containerInfo>
                        </div>
                        
                        <div className="col-12 mt-2">
                            <div>
                                Commodity Details (maximum {this.props.maxCommodities} per container)<br/>
                                <em>Use this for items such as food, hardware etc. Use "Add vehicles" option below to add vehicles</em><br />
                                <strong>Total: {this.state.commodityInputData.length}</strong>
                            </div>
                            <div className="mb-2">
                                <button type="button" className="btn btn-success mb-2"
                                    onClick={() => this.addCommodityToContainer()}>Add Commodity</button>  
                            </div>   
                            <div className="row">
                                {commodityDetailsList}
                            </div>
                        </div>

                        <div className="col-10">
                            <hr/>
                        </div>

                        <div className="col-12">
                            <div>
                                Vehicle Details (maximum {this.props.maxVehicles} per container)<br/>
                                <strong>Total: {this.state.vehicleInputData.length}</strong>
                            </div>
                            <div className="mb-2">
                                <button type="button" className="btn btn-success mb-2" 
                                    onClick={() => this.addVehicleToContainer()}>Add vehicle</button>
                            </div>
                            <div className="row">
                                {vehicleDetailsList}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}